module.exports = __webpack_public_path__ + "static/g7-866c7f77b89e8cce35b8e87679bbd017.jpg";